import { Collapse } from '@egw/components'
import { type ReactNode, type FC } from 'react'
import { twMerge } from 'tailwind-merge'
import cx from 'classnames'

interface Props {
  linkText: string
  expandedContent: ReactNode
  testId?: string
  className?: string
}

/**
 * How It Works expandable box
 * @param linkText - Collapsed link text
 * @param expandedContent - Expanded content
 * @param testId - Test id
 * @returns React.FC
 */

export const HowItWorks: FC<Props> = ({ linkText, expandedContent, testId = 'how-it-works', className }) => {
  // Component base class names. Can be overridden by className property.
  const baseClass = cx('text-text-action typo-primary-base-semibold-link justify-start')
  const finalClasses = twMerge(baseClass, className)

  return (
    <Collapse title={linkText} className={finalClasses} testId={testId}>
      <div className="mt-sm p-sm bg-alertInfoBg text-btnPrimaryInvertedText rounded-md">{expandedContent}</div>
    </Collapse>
  )
}
